export const DEFAULT_AWS_RESERVED_TERM = "yrTerm1Standard.noUpfront";
export const DEFAULT_AZURE_RESERVED_TERM = "yrTerm1Standard.allUpfront";

const AZURE_RESERVED_TERMS = new Set([
    "yrTerm1Standard.allUpfront",
    "yrTerm3Standard.allUpfront",
    "yrTerm1Standard.hybridbenefit",
    "yrTerm3Standard.hybridbenefit",
]);

/**
 * Azure exposes all-upfront and hybrid-benefit terms, while AWS uses the
 * no-upfront term by default. Normalize old persisted AWS defaults so an
 * existing Azure visitor does not query a pricing key Azure never provides.
 */
export default function resolveReservedTerm(
    pathname: string,
    reservedTerm: string | undefined,
) {
    if (pathname.includes("azure")) {
        return reservedTerm && AZURE_RESERVED_TERMS.has(reservedTerm)
            ? reservedTerm
            : DEFAULT_AZURE_RESERVED_TERM;
    }

    return reservedTerm || DEFAULT_AWS_RESERVED_TERM;
}
